import React from 'react';
import { useSelector } from 'react-redux';
import logo from 'Images/faraday_logo.svg';
import logoDark from 'Images/faraday-logo-dark.svg';
import { selectApiVersion } from 'store/Faraday/selectors';
import {
  ContainerBox, Box, LoginLogoContainer, Logo
} from './styled';
import useTheme from 'Hooks/UseTheme';

const Container = ({ children, width, height }) => {
  const apiVersion = useSelector(selectApiVersion);
  const frontVersion = process.env.REACT_APP_VERSION;
  const { theme } = useTheme();

  return (
    <ContainerBox>
      <Box width={ width } height={ height }>
        <LoginLogoContainer>
          <Logo src={ theme === 'light' ? logo : logoDark } alt="Faraday" title={ `Server: ${apiVersion}\nClient: ${frontVersion}` } />
        </LoginLogoContainer>
        {children}
      </Box>
    </ContainerBox>
  );
};

export default Container;
